
import { reportReadStatus, reportStatus, questionStatus, workflowHallStatus, hallStatus } from 'json/sign'
import { filterLabelsActive, readReportLabels } from './pt-active-sign-notes/active-sign-notes'

export function filterLabelsFunction (detail) {
  let labels = JSON.parse(JSON.stringify(filterLabelsActive))
  switch (detail.ruleActivityCode) {
    case 'REPORT_INTERPRET':
      labels.forEach(item => {
        if (item.value === 'userRegistrationStatus') {
          item.options = [...reportStatus, ...reportReadStatus]
        }
      })
      labels = labels.concat(readReportLabels)
      break
    case 'LIFE_EXPERIENCE_HALL':
      labels.forEach(item => {
        if (item.value === 'userRegistrationStatus') {
          item.options = [...hallStatus, ...workflowHallStatus]
        }
      })
      break
    case 'TWENTIETH_ANNIVERSARY_ACT':
      labels.forEach(item => {
        if (item.value === 'userRegistrationStatus') {
          item.options = [...hallStatus, ...workflowHallStatus]
        }
      })
      break
    default:
      labels = filterLabelsActive
      break
  }
  if (detail.type === 'QUESTIONNAIRE') {
    labels.forEach(item => {
      if (item.value === 'userRegistrationStatus') {
        item.options = questionStatus
      }
    })
  }
  return labels
}
